import { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { usePlatformAccessLevel } from '../features/platformPermissions/usePlatformAccessLevel';
import { SwotTab } from '../features/context/SwotTab';
import { InterestedPartiesTab } from '../features/context/InterestedPartiesTab';
import { ContextChangesTab } from '../features/context/ContextChangesTab';

export function ContextPage() {
  const { canEdit: canEditContext } = usePlatformAccessLevel('context.access');
  const { canView: canViewContextChanges, canEdit: canEditContextChanges } =
    usePlatformAccessLevel('context_changes.access');
  const [tab, setTab] = useState('foda');

  return (
    <div className='space-y-6'>
      <div>
        <h1 className='text-2xl font-bold text-foreground'>Contexto de la organización</h1>
        <p className='text-sm text-muted-foreground mt-1'>
          Análisis FODA (ISO 4.1), partes interesadas (ISO 4.2) y cambios de contexto.
        </p>
      </div>

      <Tabs value={tab} onValueChange={setTab}>
        <TabsList>
          <TabsTrigger value='foda'>FODA</TabsTrigger>
          <TabsTrigger value='partes'>Partes interesadas</TabsTrigger>
          {canViewContextChanges && <TabsTrigger value='contexto'>Contexto</TabsTrigger>}
        </TabsList>
        <TabsContent value='foda'>
          <SwotTab canEdit={canEditContext} />
        </TabsContent>
        <TabsContent value='partes'>
          <InterestedPartiesTab canEdit={canEditContext} />
        </TabsContent>
        {canViewContextChanges && (
          <TabsContent value='contexto'>
            <ContextChangesTab canEdit={canEditContextChanges} />
          </TabsContent>
        )}
      </Tabs>
    </div>
  );
}

export default ContextPage;
